import React from 'react';
import './MediaKit.css';

function MediaKit() {
  return (
    <div className="mediakit-container">
      <div className="mediakit-page">
        {/* Cabecera */}
        <div className="header">
          <h1>📊 Marketing Simulator</h1>
          <p className="tagline">Aprende marketing digital sin gastar dinero real</p>
        </div>

        {/* Qué es */}
        <div className="section">
          <h2>🔍 ¿Qué es?</h2>
          <p>Herramienta web gratuita que permite simular campañas publicitarias en <strong>Instagram, Google y TikTok</strong>. Los usuarios ajustan presupuesto, calidad del anuncio y targeting, viendo en tiempo real el impacto en <strong>ROAS, CTR, CPC y ventas estimadas</strong>.</p>
        </div>

        {/* Para quién */}
        <div className="section">
          <h2>👥 Para quién</h2>
          <div className="grid-3">
            <div className="card"><strong>🎓 Estudiantes</strong><br />Aprenden haciendo, no solo con teoría.</div>
            <div className="card"><strong>📈 Profesionales</strong><br />Testean hipótesis sin quemar presupuesto.</div>
            <div className="card"><strong>🎬 Creadores</strong><br />Recomiendan herramientas útiles y gratuitas.</div>
          </div>
        </div>

        {/* Beneficios */}
        <div className="section">
          <h2>🤝 ¿Por qué colaborar?</h2>
          <div className="grid-2">
            <div className="card">
              <strong>Para ti (creador):</strong>
              <ul><li>✅ Acceso vitalicio a funciones premium</li><li>✅ Menciones como colaborador oficial</li><li>✅ Influencia en el desarrollo</li></ul>
            </div>
            <div className="card">
              <strong>Para tu comunidad:</strong>
              <ul><li>✅ Herramienta 100% gratuita</li><li>✅ Útil para aprender o hacer retos</li><li>✅ Valor real sin coste</li></ul>
            </div>
          </div>
        </div>

        {/* Estadísticas */}
        <div className="section">
          <h2>📊 Marketing Simulator hoy</h2>
          <div className="stats">
            <div><div className="stat-number">🚀 Mayo 2026</div><div className="stat-label">Lanzamiento</div></div>
            <div><div className="stat-number">100%</div><div className="stat-label">Gratuito</div></div>
            <div><div className="stat-number">5+</div><div className="stat-label">Combinaciones</div></div>
            <div><div className="stat-number">📱</div><div className="stat-label">Responsive</div></div>
          </div>
        </div>

        {/* Formas de colaborar */}
        <div className="section">
          <h2>🎯 Formas de colaborar</h2>
          <div className="badges">
            <span className="badge">🤝 Mención en redes</span>
            <span className="badge">📹 Directo / Vídeo</span>
            <span className="badge">📧 Newsletter</span>
            <span className="badge">🎲 Reto / Sorteo</span>
            <span className="badge">🔗 Link en bio</span>
          </div>
        </div>

        {/* Captura del simulador (placeholder) */}
<div className="section">
  <h2>📸 Así se ve</h2>
  <div style={{ 
    background: '#1f2937', 
    padding: '20px', 
    borderRadius: '16px',
    textAlign: 'center'
  }}>
    <img 
      src='/demo.png'
      alt="Marketing Simulator preview" 
      style={{ 
        width: '100%',
        maxWidth: '600px',
        height: 'auto',
        borderRadius: '12px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)'
      }} 
    />
    <p style={{ color: '#9ca3af', marginTop: '12px', fontSize: '14px' }}>
      Vista del simulador mostrando métricas clave
    </p>
  </div>
</div>

        {/* Contacto */}
        <div className="footer">
          <p>📧 juanjecontact2@gmail.com</p>
          <p>🌐 https://simulator-marketing.vercel.app</p>
        </div>
      </div>
    </div>
  );
}

export default MediaKit;